module.exports = __webpack_public_path__ + "img/1.2.9d4bbe88.jpg";